import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import webSDKCore from '@tencent/ti18n-websdkcore';
import zhCN from 'antd/lib/locale/zh_CN';
import enGB from 'antd/lib/locale/en_GB';
import App from './App';
import '@ux-lab-web/shared/i18n';
import { bootstrap } from '@ux-lab-web/shared/env';

// 应用启动初始化
bootstrap({ app: 'capturer' });

ReactDOM.render(
  <BrowserRouter>
    <ConfigProvider locale={webSDKCore.language === 'en' ? enGB : zhCN}>
      <App />
    </ConfigProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);
